import { Constantes } from '../../shared/constant/constantes';
import { InformacionSerie } from '../entities/informacion-serie';
import { TablaCatalogoDatos } from '../entities/tabla-catalogo-datos';

export class UtilidadGeneraTabla {

    public constante: Constantes = new Constantes();

    public generaTablaDetalleFromJson(jsonTasas: Array<any>, tipo: string): any {
        const listaIDSubmenuNoData = ["SECTORIZACION_MONETARIA_CREDITO", "AGREGADOS_MONETARIOS_CREDITICIOS", "SECTOR_PUBLICO_NO_FINANCIERO", "GOBIERNO_NACIONAL_CENTRAL",
            "GOBIERNOS_TERRITORIALES", "DEUDA_PUBLICA", "TES", "FOGAFIN", "FRECH", "PLI", "BALANZA_CAMBIARIA", "OMA", "RESUMEN_EJERCICIO_SUBASTA_OPCIONES", "SUBASTA_OPCION", "OPER_FX_SWAPS",
            "SUBASTA_COMPRA_DIRECTA_DOLARES", 'PIB_OTROS', 'PRODUCCION_INDUSTRIAL', 'MERCADO_LABORAL_OTROS', 'CUENTAS_FINAN_FLUJOS', 'CUENTAS_FINAN_SALDOS'];
        let tablaResultado: Array<Array<InformacionSerie>> = new Array();
        let infoSerie: InformacionSerie;
        if (jsonTasas != undefined) {
            jsonTasas.forEach(element => {
                let datosTablaSerie: Array<InformacionSerie> = new Array();
                infoSerie = new InformacionSerie();
                var urlPagina = element.enlace_pagina_externa;
                const idEncontrado = listaIDSubmenuNoData.find(sm => sm == element.idSubmenuJson);
                if (idEncontrado != undefined) {
                    infoSerie.enlace_pagina_externa = urlPagina;
                    infoSerie.clasificacion = this.constante.TIPO_URL_EXTERNA;
                    infoSerie.nombre = element.nombre;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = '<a href="' + urlPagina + '" target="_blank"> <img src="./assets/img/cursor.jpg" height="25px" width="25px"> </a>';
                    datosTablaSerie.push(infoSerie);

                    tablaResultado.push(datosTablaSerie);
                } else {
                    infoSerie.id = Number(element.id);
                    infoSerie.nombre = element.categoria;

                    infoSerie.menu = element.idMenuJson;
                    infoSerie.submenu = element.idSubmenuJson;

                    infoSerie.enlace_pagina_externa = urlPagina;
                    infoSerie.clasificacion = this.constante.TIPO_URL_INTERNA;
                    datosTablaSerie.push(infoSerie);

                    if (tipo == 'TASA_CAMBIO_OTROS') {
                        infoSerie = new InformacionSerie();
                        infoSerie.nombre = element.clasificacion;
                        datosTablaSerie.push(infoSerie);
                    }

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.nombre;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.periodicidad;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.fecha_ultima_publicacion_disponible;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.unidad;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.fecha_ultimo_dato_publicado;
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = '<strong>' + element.valor_dato_publicado + '</strong>';
                    datosTablaSerie.push(infoSerie);

                    if (tipo == 'TASA_CAMBIO_OTROS' || tipo == 'TASA_CAMBIO_PAISES_VECINOS') {
                        infoSerie = new InformacionSerie();
                        infoSerie.nombre = element.tipo;
                        datosTablaSerie.push(infoSerie);
                    }

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = '<a (routerLink)=' + infoSerie + ' target="_self"> <img src="./assets/img/cursor.jpg" height="25px" width="25px"> </a>';
                    datosTablaSerie.push(infoSerie);

                    infoSerie = new InformacionSerie();
                    infoSerie.nombre = element.fecha_proxima_publicacion;
                    datosTablaSerie.push(infoSerie);

                    tablaResultado.push(datosTablaSerie);
                }
            });
        }
        return tablaResultado;
    }

    public resaltarPalabra(palabraBusqueda: string, palabraOriginal: string): string {
        var result = palabraOriginal;
        var listaPalabrasBusqueda = palabraBusqueda.split(' ');
        listaPalabrasBusqueda.forEach((pb) => {
            var p = this.getPalabraFromNombre(pb, palabraOriginal);
            result = result.replace(p, "<mark>" + p + "</mark>");
        });
        return result;
    }

    public isPalabraCoincide(palabraMinuscula: string, nombre: any): boolean {
        var resultado = false;
        var nombreMin = this.validaPalabra(nombre);
        if (nombreMin.includes(palabraMinuscula)) {
            resultado = true;
        } else if (nombre != null || nombre.length > 0) {


            const queryWords = palabraMinuscula.split(' ');
            var encontrado = queryWords.every(word =>
                nombreMin.includes(word)
            );

            resultado = encontrado;

            /*var listaPalabrasNombre = nombre.split(' ');
            listaPalabrasNombre.forEach((n: string) => {
                var min = this.validaPalabra(n);
                if (min === palabraMinuscula) {
                    resultado = true;
                }
            });*/
        } else {
            resultado = false;
        }
        return resultado;
    }

    public getPalabraFromNombre(palabraMinuscula: string, nombre: any): string {
        var result: string = '';
        if (nombre != null || nombre.length > 0) {
            var listaPalabrasNombre = nombre.split(' ');
            listaPalabrasNombre.forEach((n: string) => {
                var min = this.validaPalabra(n);
                if (min === palabraMinuscula) {
                    result = n;
                }
            });
        }
        return result;
    }

    public clonarObjeto(obj: any) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        var temp = obj.constructor();
        for (var key in obj) {
            temp[key] = this.clonarObjeto(obj[key]);
        }

        return temp;
    }

    /** Obtener la imagen de cada titulo del catalogo */
    public getObjTablaCatalogo(id: number, tablaCatalogo: TablaCatalogoDatos): TablaCatalogoDatos {
        var img: string;
        switch (id) {
            case 1000:
                //		Precios e inflación 1000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-inflacion.png";
                tablaCatalogo.descripcion = 'Inflación anual y meta / Índice de precios al consumidor (IPC) / Indicadores de inflación básica / Índice de precios del productor (IPP) / Índices de precios de vivienda / UVR / Metales preciosos';
                break;
            case 2000:
                //		Tasas de interés y sector financiero 2000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-tasas-interes.png";
                tablaCatalogo.descripcion = 'Tasa de interés de política / Indicador Bancario de Referencia (IBR) / Tasas de captación / Tasas de colocación / Agregados monetarios / Encaje y exigibilidades / Cartera / COLCAP / TES';
                break;
            case 3000:
                //		Operaciones del Banco en el mercado y Reservas internacionales 3000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-reservas.png";
                tablaCatalogo.descripcion = 'Reservas internacionales / Operaciones en el mercado cambiario / Operaciones de mercado abierto (OMAS) / Expansión / Contracción / Subastas / Convocatorias / Operaciones Forward NDF';
                break;
            case 4000:
                //		Tasas de cambio 4000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-tasas-cambio.png";
                tablaCatalogo.descripcion = 'Balanza de pagos / Términos de intercambio / Deuda externa / Posición de liquidez internacional (PLI) / Balanza cambiaria / Tasas de cambio / Comportamiento del mercado del dólar (Tiempo real) / Comercio exterior / Derivados';
                break;
            case 5000:
                //		Actividad económica, mercado laboral y cuentas financieras 5000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-mercado.png";
                tablaCatalogo.descripcion = 'Producto interno bruto (PIB) / Pulso Económico Regional (PER) / Producción industrial / Ocupación y desempleo / Vacantes / Salarios / Población / Saldos de cuentas financieras / Flujos de cuentas financieras';
                break;
            case 6000:
                //		Sector público y deuda pública 6000
                tablaCatalogo.imagen = "./assets/img/catalogo/she-publico.png";
                tablaCatalogo.descripcion = 'Sector público no financiero / Gobierno Nacional Central /Gobiernos territoriales / Deuda pública / Subastas administradas / TES';
                break;
            case 7000:
                //		Sistemas de pago 7000
                tablaCatalogo.imagen = "./assets/img/catalogo/sistemas_pago.png";
                tablaCatalogo.descripcion = '';
                break;
            case 8000:
                //		Billetes y monedas 8000
                tablaCatalogo.imagen = "./assets/img/catalogo/billetes_monedas.png";
                tablaCatalogo.descripcion = '';
                break;
            case 9000:
                //		Estados financieros 9000
                tablaCatalogo.imagen = "./assets/img/catalogo/estados_financieros.png";
                tablaCatalogo.descripcion = '';
                break;
            default:
                tablaCatalogo.imagen = '';
                tablaCatalogo.descripcion = '';
                break;
        }
        return tablaCatalogo;
    }

    public ordenaTablaCatalogo(listaTablaCatalogo: Array<TablaCatalogoDatos>) {
        listaTablaCatalogo.forEach(catalogoPadre => {
            catalogoPadre.enlaces.sort(function (a, b) {
                const horaA = a.ordenMenu;
                const horaB = b.ordenMenu;
                if (horaA < horaB) {
                    return -1
                }
                if (horaA > horaB) {
                    return 1
                }
                return 0;
            });
            catalogoPadre.enlaces.forEach(catalogoHijo => {
                if (catalogoHijo.menuHijos != undefined) {
                    catalogoHijo.menuHijos.sort(function (a, b) {
                        const horaA = a.ordenMenu;
                        const horaB = b.ordenMenu;
                        if (horaA < horaB) {
                            return -1
                        }
                        if (horaA > horaB) {
                            return 1
                        }
                        return 0;
                    });
                }
            });
        });

    }

    public validaPalabra(value: string): string {
        var palabraABuscarMinus = this.normalizeString(value);
        palabraABuscarMinus = palabraABuscarMinus.replace('(', '');
        palabraABuscarMinus = palabraABuscarMinus.replace(')', '');
        palabraABuscarMinus = palabraABuscarMinus.replace(/,/g, '');
        if (['trm'].includes(palabraABuscarMinus)) {
            palabraABuscarMinus = 'tcrm';
        }
        return palabraABuscarMinus;
    }

    private normalizeString(str: string): string {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }
}